import {
    deleteThinClientDeviceDetails,
    fetchThinClientDeviceDetails,
    fetchThinClientStatusDetails,
    setThinClientDeviceDetails,
    toggleThinClientUseCase,
    restartApplication,
    setThinClientStatusDetailsToRestartedState,
    setThinClientStatusDetailsToRestartInProgressState,
    changeThinClientUseCase
} from "../network/ThinClientOverviewNetworkAPI";
import {getTimestampNow} from "../../../util/Util";

export const ThinClientOverviewReducer = (state, action) => {
    switch (action.type) {
        case "RECEIVE_DATA":
            return {...state, ...action.data, loadingOverview: false, timestamp: getTimestampNow()}
        case "LOAD_VIEW":
            fetchThinClientDeviceDetails(action.data.dispatcher)
            return state
        case "LOAD_STATUS":
            fetchThinClientStatusDetails(action.data.dispatcher, state)
            return state
        case "DELETE_DEVICE_DATA":
            deleteThinClientDeviceDetails(action.data.dispatcher, action.data.mac)
            return state
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        case "ADD_DEVICE_DATA":
            setThinClientDeviceDetails(action.data.dispatcher, action.data.stateValues, action.data.mac)
            return state
        case "DEPLOY_THIN_CLIENT":
            restartApplication(action.data.dispatcher, action.data.mac)
            return state
        case "TOGGLE_USECASE":
            toggleThinClientUseCase(action.data.dispatcher, action.data.mac, action.data.useCase)
            return state
        case "CHANGE_USECASE":
            changeThinClientUseCase(action.data.dispatcher, action.data.mac, action.data.useCase, action.data.showCustomAlert)
            return state
        case "UPDATE_STATUS_LOADER":
            return {...state, loadingStatusDevices: {...state.loadingStatusDevices, [action.data.mac]: {...state.loadingStatusDevices[action.data.mac], [action.data.loadingField]: action.data.loaderVisible }}}
        case "LOAD_VIEW_FOR_GREENGRASS_RESTART_COMPLETE":
            setThinClientStatusDetailsToRestartedState(action.data.dispatcher, state, action.data.mac)
            return state
        case "LOAD_VIEW_FOR_GREENGRASS_RESTART":
            setThinClientStatusDetailsToRestartInProgressState(action.data.dispatcher, state, action.data.mac)
            return state
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/thinclient/reducer/ThinClientOverviewReducer.js